import { SvgIcon } from '@mui/material';

const TwoDay = props => (
  <SvgIcon
    width='32.343'
    height='34.637'
    viewBox='0 0 32.343 34.637'
    {...props}
  >
    <g id='Group_115' data-name='Group 115'>
      <path
        id='Path_34'
        data-name='Path 34'
        d='M137.531,8.008,122.211.065a.578.578,0,0,0-.531,0l-4.225,2.188,15.58,8.087Z'
        transform='translate(-105.764 0)'
        fill='#dc0032'
      />
      <path
        id='Path_35'
        data-name='Path 35'
        d='M82.457,37.266,66.87,29.184l-4.2,2.176,15.586,8.082Z'
        transform='translate(-56.433 -26.279)'
        fill='#dc0032'
      />
      <path
        id='Path_36'
        data-name='Path 36'
        d='M10.363,57.606,5.976,59.88l15.586,8.082,4.387-2.274Z'
        transform='translate(-5.381 -51.872)'
        fill='#dc0032'
      />
      <path
        id='Path_37'
        data-name='Path 37'
        d='M225.086,126.024l4.3-2.228v-3.85l-4.3,2.228Z'
        transform='translate(-202.682 -108.007)'
        fill='#dc0032'
      />
      <path
        id='Path_38'
        data-name='Path 38'
        d='M179.447,92.892v4.8a.577.577,0,0,1-.312.514l-5.449,2.829a.6.6,0,0,1-.266.063.583.583,0,0,1-.577-.577v-4.2l-4.491,2.326V116.19l15.274-7.92a.582.582,0,0,0,.312-.514V90.569Z'
        transform='translate(-151.595 -81.554)'
        fill='#dc0032'
      />
      <path
        id='Path_39'
        data-name='Path 39'
        d='M.018,90.543,0,90.534v17.187a.582.582,0,0,0,.312.514h0l15.272,7.919H15.6V98.611L.018,90.529Zm8.481,9.62a1.776,1.776,0,0,0-.766-.71.739.739,0,0,0-.785,0,1.62,1.62,0,0,0-.409,1.1L4.027,99.132A3.749,3.749,0,0,1,4.568,97.4a1.443,1.443,0,0,1,1.111-.585,4.405,4.405,0,0,1,1.985.525,7.442,7.442,0,0,1,2.059,1.308,5.155,5.155,0,0,1,1.157,1.663,4.72,4.72,0,0,1,.422,1.91,2.9,2.9,0,0,1-.483,1.7A3.7,3.7,0,0,1,9.062,105.1a10.473,10.473,0,0,0-1.013.4,5.139,5.139,0,0,0-.6.375l3.915,1.89v2.5l-7.521-3.687a4.132,4.132,0,0,1,.785-2.132,5.95,5.95,0,0,1,2.459-1.617A4.021,4.021,0,0,0,8.5,102a1.277,1.277,0,0,0,.308-.836,1.9,1.9,0,0,0-.3-1'
        transform='translate(0 -81.518)'
        fill='#dc0032'
      />
    </g>
  </SvgIcon>
);

export default TwoDay;
